import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const HeroSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-32 sm:pt-36">
      {/* Background Image with Gradient Overlay */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-dark via-primary to-primary-light opacity-95"></div>
        <img
          src="https://public.readdy.ai/ai/img_res/c6c46621f6ceea1d4cada95fcaa0a650.jpg"
          alt="Instalación profesional de pladur en Barcelona"
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 py-32 text-center">
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-white font-extrabold text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-tight mb-6"
        >
          Pladur Barcelona<br />
          <span className="text-accent-blue">instalación profesional y garantizada</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-white/90 text-base sm:text-lg md:text-xl max-w-3xl mx-auto mb-12 leading-relaxed px-4"
        >
          Especialistas en tabiques, trasdosados, falsos techos y aislamientos acústicos y térmicos. Acabado impecable, ejecución rápida y presupuesto sin compromiso.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12 px-4"
        >
          <a
            href="tel:+34629501941"
            className="group relative bg-white text-primary-dark px-6 sm:px-8 py-4 rounded-lg font-bold text-base sm:text-lg transition-all duration-300 hover:shadow-2xl hover:scale-105 flex items-center space-x-3 whitespace-nowrap animate-pulse-subtle w-full sm:w-auto justify-center"
          >
            <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-phone-line text-white text-xl"></i>
            </div>
            <span className="truncate">+34 629 501 941</span>
          </a>
          <a
            href="#servicios"
            className="border-2 border-white bg-transparent text-white px-6 sm:px-8 py-4 rounded-lg font-bold text-base sm:text-lg transition-all duration-300 hover:bg-white hover:text-primary-dark flex items-center space-x-2 whitespace-nowrap w-full sm:w-auto justify-center"
          >
            <span>Ver servicios</span>
            <i className="ri-arrow-right-up-line text-xl"></i>
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="flex flex-col sm:flex-row flex-wrap items-center justify-center gap-3 sm:gap-4 px-4"
        >
          <div className="bg-white/20 backdrop-blur-sm px-4 sm:px-6 py-3 rounded-full flex items-center space-x-2 w-full sm:w-auto justify-center max-w-xs">
            <i className="ri-check-line text-accent-blue text-xl flex-shrink-0"></i>
            <span className="text-white text-xs sm:text-sm font-medium truncate">Presupuesto sin compromiso</span>
          </div>
          <div className="bg-white/20 backdrop-blur-sm px-4 sm:px-6 py-3 rounded-full flex items-center space-x-2 w-full sm:w-auto justify-center max-w-xs">
            <i className="ri-star-line text-accent-blue text-xl flex-shrink-0"></i>
            <span className="text-white text-xs sm:text-sm font-medium truncate">Acabado impecable</span>
          </div>
          <div className="bg-white/20 backdrop-blur-sm px-4 sm:px-6 py-3 rounded-full flex items-center space-x-2 w-full sm:w-auto justify-center max-w-xs">
            <i className="ri-home-smile-line text-accent-blue text-xl flex-shrink-0"></i>
            <span className="text-white text-xs sm:text-sm font-medium truncate">Trabajo en viviendas ocupadas</span>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1 }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10"
      >
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
          className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2"
        >
          <div className="w-1 h-2 bg-white rounded-full"></div>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default HeroSection;
